<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.platids"
              filterable
              placeholder="筛选所属平台"
              clearable
              multiple
              :max-tag-count="2"
              @on-change="updateplatids"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}<span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="7">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.app_ids"
              filterable
              placeholder="选择代理"
              multiple
              :max-tag-count="3"
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName
                }}<span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">所在游戏:</span>
            <Select
              v-model="table.params.game_id"
              placeholder="输入或选择所在游戏"
              filterable
              clearable
            >
              <Option
                v-for="(item, index) in select.game_List"
                :label="item.name"
                :value="item.value"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.value }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">所在IP:</span>
            <Input
              v-model="table.params.ip"
              placeholder="筛选所在IP"
              clearable
            ></Input>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 10px">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">选择日期:</span>
            <DatePicker
              type="date"
              format="yyyy-MM-dd"
              :options="date_opts"
              v-model="select.dataTime1"
              placeholder="选择日期"
              @on-change="datacha"
              :clearable="false"
            ></DatePicker>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">时间范围:</span>
            <TimePicker
              type="timerange"
              confirm
              :value="select.dataTime2"
              placeholder="选择时间范围"
              @on-change="changeTime"
              :clearable="false"
            ></TimePicker>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">流水单号:</span>
            <Input
              v-model.trim="table.params.order_no"
              placeholder="请输入流水单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="筛选玩家ID"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="2">
          <!--          <Button-->
          <!--            :disabled="table.platids.length == 0 || table.app_ids.length == 0"-->
          <!--            type="primary"-->
          <!--            :loading="loading"-->
          <!--            @click="gitList(1)"-->
          <!--            >查询</Button-->
          <!--          >-->
          <Button
            :disabled="table.app_ids.length == 0"
            type="primary"
            :loading="loading"
            @click="gitList(1)"
            >查询</Button
          >
        </Col>
        <Col span="2">
          <Button type="primary" @click="addDownshow">变更类型</Button>
        </Col>
        <Col span="3">
          <span style="line-height: 33px">
            变动金额：{{ getCustomFixed(table.sum) }}</span
          >
        </Col>
        <Col span="3">
          <span style="line-height: 33px"> 记录数量：{{ table.total }}</span>
        </Col>
      </Row>
    </Card>
    <div class="divPancl">
      <Collapse accordion @on-change="Panelchange" v-model="table.name">
        <Panel
          v-for="(item, index) in table.list"
          :key="index"
          :name="String(index + 1)"
        >
          <div style="float: right; width: 96%">
            <span class="row-span1">
              <h4>{{ index + 1 }}</h4>
            </span>
            <span class="row-span">
              <h4>{{ item.platName }}</h4>
            </span>
            <span class="row-span">
              <h4>{{ item.appName }}</h4>
            </span>
            <span class="row-span">
              <h4>变动金额：{{ getCustomFixed(item.sum / 10000) }}</h4>
            </span>
            <span class="row-span">
              <h4>记录数量：{{ item.total }}</h4>
            </span>
          </div>
          <div slot="content">
            <Table
              style="margin-top: 10px"
              border
              size="large"
              :max-height="350"
              :columns="table.columns"
              :data="table.data"
            ></Table>
            <Page
              v-show="table.data.length"
              style="margin-top: 10px"
              :current="table.params.page"
              :total="item.total"
              :page-size-opts="table.pageSizes"
              :page-size="table.params.limit"
              show-sizer
              @on-page-size-change="limitchange"
              @on-change="pagechange"
            ></Page>
          </div>
        </Panel>
      </Collapse>
    </div>
    <!-- 变更类型 -->
    <Modal v-model="optType.show" width="700">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>变更类型</span>
      </p>
      <div>
        <p>
          可展示变更类型
          <Checkbox
            :indeterminate="optType.indeterminate"
            :value="optType.checkAll"
            @click.prevent.native="handleCheckAll"
            >全选</Checkbox
          >
        </p>
        <CheckboxGroup
          v-model="table.params.source_type"
          @on-change="checkAllGroupChange"
        >
          <Collapse v-model="optType.value">
            <Panel name="1">
              财务类型
              <p slot="content">
                <Checkbox
                  style="margin: 10px; width: 130px"
                  v-for="(item, index) in optType.params.pay_list"
                  :key="index"
                  :label="item.source"
                  >{{ item.name }}</Checkbox
                >
              </p>
            </Panel>
            <Panel name="2">
              返佣类型
              <p slot="content">
                <Checkbox
                  style="margin: 10px; width: 130px"
                  v-for="(item, index) in optType.params.commit_list"
                  :key="index"
                  :label="item.source"
                  >{{ item.name }}</Checkbox
                >
              </p>
            </Panel>
            <Panel name="3">
              游戏类型
              <p slot="content">
                <Checkbox
                  style="margin: 10px; width: 130px"
                  v-for="(item, index) in optType.params.game_list"
                  :key="index"
                  :label="item.source"
                  >{{ item.name }}</Checkbox
                >
              </p>
            </Panel>
            <Panel name="4">
              赠送类型
              <p slot="content">
                <Checkbox
                  style="margin: 10px; width: 130px"
                  v-for="(item, index) in optType.params.give_list"
                  :key="index"
                  :label="item.source"
                  >{{ item.name }}</Checkbox
                >
              </p>
            </Panel>
          </Collapse>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="info" @click="optType.show = false">保存</Button>
      </div>
    </Modal>

    <!-- 变更详情 -->
    <Modal v-model="optTypeModal.show" :width="getTableWidth()">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>变更详情</span>
      </p>
      <!-- <optTable :sourcenum="optTypeModal.sourcenum" :listdata="optTypeModal.list" :opttype="optTypeModal.opttypename"></optTable> -->
      <allTable
        :sourcenum="optTypeModal.sourcenum"
        :listdata="optTypeModal.list"
        :opttype="optTypeModal.opttypename"
      ></allTable>
    </Modal>
  </div>
</template>
<script>
import { TransTopReq, GetAllGameList } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
import allTable from './components/allTable.vue'
export default {
  name: 'AppPointRecord',
  components: {
    publicTable,
    allTable
  },
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      select: {
        game_List: [],
        dataTime1: this.getCurrentZeroDay(),
        dataTime2: ['00:00:00', '23:59:59'],
        dataTime: [
          this.getCurrentZeroDay(),
          new Date(new Date().setHours(23, 59, 59, 59))
        ]
      },
      optType: {
        show: false,
        value: ['1', '2', '3', '4'],
        params: {},
        indeterminate: true,
        checkAll: false,
        checkAllGroup: [],
        sourceList: []
      },
      table: {
        name: '1',
        list: [],
        platids: [],
        params1: {},
        params: {
          platform: 0,
          app_id: 0,
          game_id: 0,
          stime: 0,
          etime: 0,
          user_id: '',
          ip: '',
          order_no: '',
          ext: '',
          nosource_type: [],
          pack_no: -1,
          source_type: [],
          page: 1,
          limit: 15
        },
        pageSizes: [15, 30, 45, 60],
        app_ids: [],
        data: [],
        columns: [
          {
            key: 'bill_no',
            align: 'center',
            width: 130,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '流水单号', '每条数据对应的流水单号')
          },
          {
            key: 'user_id',
            align: 'center',
            width: 100,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家ID', '显示该对流水对应的玩家ID')
          },
          {
            key: 'user_name',
            align: 'center',
            width: 100,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家昵称', '显示该对流水对应的玩家昵称')
          },
          {
            key: 'chang_point',
            align: 'center',
            width: 100,
            resizable: true,
            render: (h, params) => {
              let str = this.optType.params['source_list'].filter(
                item => item.source == params.row.opt_code
              )[0].name
              this.optTypeModal.opttypename = str
              return h('span', str)
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                '变更类型',
                '引起玩家账户余额变动的操作；'
              )
            }
          },
          {
            key: 'game_name',
            align: 'center',
            width: 130,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '所在游戏', '显示此条流水发生所在的游戏；')
          },
          {
            key: 'level',
            align: 'center',
            width: 130,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '所在房间',
                '当一个游戏有多个平行场时，显示该玩家在那一个房间产生的流水'
              )
          },
          {
            key: 'old_point',
            align: 'center',
            width: 100,
            resizable: true,
            render: (h, params) => {
              let start = this.getCustomFixed(params.row.old_point / 10000)
              let end = this.getCustomFixed(params.row.old_bank_point / 10000)
              return h('div', [
                h('p', start)
                // h('p', { style: { color: 'red' } }, `(${end})`)
              ])
              // return h('span', `${start}(${end})`);
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '玩家账户余额（变动前）',
                '账户发生变动前，该玩家账户的余额；界面信息展示【玩家钱包余额+（玩家钱包余额+玩家银行余额）】'
              )
          },
          {
            key: 'new_point',
            align: 'center',
            width: 100,
            resizable: true,
            render: (h, params) => {
              let start = this.getCustomFixed(params.row.new_point / 10000)
              let end = this.getCustomFixed(params.row.new_bank_point / 10000)
              return h('div', [
                h('p', start)
                // h('p', { style: { color: 'red' } }, `(${end})`)
              ])
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '玩家账户余额（变动后）',
                '账户发生变动后，该玩家账户的余额；界面信息展示【玩家钱包余额+（玩家钱包余额+玩家银行余额）】'
              )
          },
          {
            key: 'chang_point',
            align: 'center',
            width: 100,
            resizable: true,
            render: (h, params) => {
              let str = params.row.chang_point / 10000
              let color = '#333'
              if (str > 0) {
                color = 'red'
              } else if (str < 0) {
                color = 'blue'
              }
              return h(
                'span',
                { style: { color: color } },
                this.getCustomFixed(str)
              )
            },
            renderHeader: (h, params) => {
              return this.renderHeader(h, '变动金额', '玩家账户变动的金额；')
            }
          },
          {
            key: 'ip',
            align: 'center',
            width: 130,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '用户所在IP',
                '显示发生此笔流水时用户所在的IP地址'
              )
          },
          {
            key: 'opt_source',
            align: 'center',
            width: 100,
            resizable: true,
            render: (h, params) => {
              let str = ''
              if (params.row.opt_source == '活动领取 5') {
                str = '大转盘'
              } else if (params.row.opt_source == '活动领取 4') {
                str = '充值返利送'
              } else {
                str = params.row.opt_source
              }
              return h('span', str)
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                '扩展信息',
                '扩展信息支持模糊查询，查询扩展信息统计项中的数据；'
              )
            }
          },
          {
            key: 'time',
            align: 'center',
            width: 110,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '变更时间', '玩家账户余额发生变动的时间；')
          },
          {
            key: 'pack_no',
            align: 'center',
            width: 100,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属子商户', '变动账户玩家所属的渠道；')
          },
          {
            key: 'pack_no',
            title: '变更详情',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        this.optTypeModal.list = []
                        let str = ''
                        let arr = this.optType.params['source_list'].filter(
                          item => item.source == params.row.opt_code
                        )
                        str = arr.length == 0 ? '' : arr[0].name
                        this.optTypeModal.sourcenum =
                          params.row.opt_code +
                          '/' +
                          params.row.game_id +
                          '/' +
                          new Date()
                        if (
                          params.row.opt_code == 3 ||
                          params.row.opt_code == 4 ||
                          params.row.opt_code == 15 ||
                          params.row.opt_code == 16
                        ) {
                          this.optTypeModal.list.push(params.row)
                          this.optTypeModal.opttypename =
                            str + '(' + params.row.game_name + ')'
                          this.optTypeModal.game_id = params.row.game_id
                          let arr = [
                            2003,
                            3001,
                            1007,
                            1005,
                            1006,
                            1002,
                            1001,
                            1015,
                            1009,
                            1010,
                            1014,
                            2001,
                            2002,
                            5001,
                            5002,
                            6001,
                            0,
                            2008,
                            1016,
                            2006,
                            2005,
                            3002,
                            4001,
                            4002,
                            2004,
                            1018,
                            1017,
                            3003,
                            5003,
                            2009,
                            2101,
                            3004,
                            2010,
                            5004,
                            5005,
                            1019,
                            1020,
                            3005,
                            2102,
                            2011,
                            3006,
                            1021,
                            2013,
                            2012
                          ]
                          if (arr.includes(params.row.game_id)) {
                            this.optTypeModal.show = true
                          } else {
                            this.$Modal.info({
                              title: '详情',
                              content:
                                '<p style="word-wrap:break-word;word-break:break-all;">' +
                                params.row.opt_detail +
                                '</p>'
                            })
                          }
                        } else {
                          this.optTypeModal.list.push(params.row)
                          this.optTypeModal.opttypename = str
                          this.optTypeModal.show = true
                        }
                      }
                    }
                  },
                  '变更详情'
                )
              ])
            }
          }
        ],
        sum: 0,
        total: 0
      },
      optTypeModal: {
        opttypename: '',
        show: false,
        list: [],
        sourcenum: '',
        game_id: ''
      },
      date_opts: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  methods: {
    getTableWidth() {
      if (
        this.optTypeModal.game_id == '2101' ||
        this.optTypeModal.game_id == '5005' ||
        this.optTypeModal.game_id == '1016'
      ) {
        return '1175'
      } else if (this.optTypeModal.game_id == '1019') {
        return '1080'
      } else if (this.optTypeModal.game_id == '2102') {
        return '1300'
      } else {
        return '1000'
      }
    },
    //日期时间处理
    datacha(date) {
      this.select.dataTime = []
      this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[0]))
      this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[1]))
    },
    //小时时间处理
    changeTime(time) {
      this.select.dataTime2 = time
      let date = moment(this.select.dataTime1).format('YYYY-MM-DD')
      this.select.dataTime = []
      this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[0]))
      this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[1]))
    },

    //获取游戏列表
    GetGameList() {
      GetAllGameList({ page: 1, page_size: 1000 }).then(res => {
        let data = res._param.data || []
        let nlist = []
        data.map(item => {
          nlist.push({
            value: item.game_id || 0,
            name: item.game_name
          })
        })
        this.select.game_List = nlist.filter(item => item.value)
      })
    },
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 6000)
    },
    //获取列表
    gitList(num) {
      if (num) {
        this.table.name = '1'
      }
      if (this.loading) return
      this.openTimer()
      let list = []
      this.table.list = []
      this.table.sum = 0
      this.table.total = 0
      let paramAppArray = this.getAllHttpAppid(this.table)
      let delArray = [...paramAppArray]
      if (paramAppArray) {
        let httpList = []
        for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
          let item = paramAppArray[k]
          let app = this.app_list.find(el => el.appid == item)
          let appName = app ? app.appName : ''
          this.table.params.stime =
            moment(
              moment(this.select.dataTime[0]).format('YYYY-MM-DD HH:mm:ss')
            ).valueOf() / 1000
          this.table.params.etime =
            moment(
              moment(this.select.dataTime[1]).format('YYYY-MM-DD HH:mm:ss')
            ).valueOf() / 1000
          let param = {
            mod: 'root',
            platid: app.platform,
            app_id: item,
            appName: appName,
            param: {
              _mod: 'manager',
              // _func: 'GetUserPointRecord',
              _func: 'GetUserPointRecord2',
              _param: {
                ...Object.assign({}, this.table.params),
                app_id: item,
                user_id: Number(this.table.params.user_id)
              }
            }
          }
          httpList.push(param)
        }
        let max = Math.min(5, httpList.length)
        for (let i = 0; i < max; i++) {
          this.toHttp(httpList, list)
        }
      }
    },
    toHttp(httpList, list) {
      if (httpList.length > 0) {
        let param = httpList[0]
        httpList.shift()
        TransTopReq(param)
          .then(res => {
            let obj = res._param
            this.table.sum += obj['sum'] / 10000
            this.table.total += obj['total']
            if (obj.list && obj.list.length) {
              this.table.data = obj.list
            }
            obj.platid = param.platid
            obj.app_id = param.app_id
            obj.appName = param.appName
            let name = this.plat_list.filter(
              item => item['id'] == param.platid
            )[0]['name']
            obj.platName = name
            obj.param = param
            this.table.list.push(obj)
            this.requestCallBack(httpList, list)
            this.toHttp(httpList, list)
          })
          .catch(error => {
            this.requestCallBack(httpList, list)
            this.toHttp(httpList, list)
          })
      }
    },

    requestCallBack(list, tableData) {
      if (list.length == 0) {
        this.closeTimer()
      }
    },

    updateplatids() {
      this.table.app_ids = []
    },

    Panelchange() {
      const _key = this.table.name
      this.table.data = []
      if (_key.length) {
        this.table.params.page = 1
        let num = Number(_key[0]) - 1
        let param = this.table.list[num]['param']
        param.param._func = 'GetUserPointRecord2'
        this.table.params1 = param
        TransTopReq(param).then(res => {
          this.table.data = res._param.list || []
        })
      }
    },
    limitchange(limit) {
      this.table.params.limit = limit
      this.table.params.page = 1
      let param = this.table.params1
      param.param._param.limit = limit
      param.param._param.page = 1
      TransTopReq(param).then(res => {
        this.table.data = res._param.list || []
      })
    },

    pagechange(page) {
      this.table.params.page = page
      let param = this.table.params1
      param.param._param.page = page
      TransTopReq(param).then(res => {
        this.table.data = res._param.list || []
      })
    },

    //变更类型是否出现
    addDownshow() {
      this.optType.show = true
    },
    handleCheckAll() {
      if (this.optType.indeterminate) {
        this.optType.checkAll = false
      } else {
        this.optType.checkAll = !this.optType.checkAll
      }
      this.optType.indeterminate = false
      if (this.optType.checkAll) {
        this.table.params.source_type = this.optType.sourceList
      } else {
        this.table.params.source_type = []
      }
    },

    checkAllGroupChange(data) {
      if (data.length === this.optType.sourceList.length) {
        this.optType.indeterminate = false
        this.optType.checkAll = true
      } else if (data.length > 0) {
        this.optType.indeterminate = true
        this.optType.checkAll = false
      } else {
        this.optType.indeterminate = false
        this.optType.checkAll = false
      }
    },
    getSourceTypelist() {
      // let platid = (this).plat_list[0]['id'] || 20;
      // let app_id = (this).app_list.filter((item) => item['platform'] == platid)[0]['id'] || 588;
      let platid = this.getinitPlatId() || 14
      let app_id =
        this.app_list.filter(item => item['platform'] == platid)[0].appid ||
        9001
      let param = {
        mod: 'root',
        platid: platid,
        app_id: app_id,
        param: {
          _mod: 'manager',
          _func: 'GetSourceType',
          _param: { app_id }
        }
      }
      TransTopReq(param).then(res => {
        let data = res._param || {}
        this.optType.params = data
        this.optType.sourceList = []
        data.source_list.map(item => {
          this.optType.sourceList.push(item.source)
        })
        this.table.params.source_type = this.optType.sourceList
        this.optType.indeterminate = true
        this.optType.checkAll = false
      })
    }
  },

  created() {
    this.getSourceTypelist()
    this.GetGameList()
  }
}
</script>
<style lang="less">
.row-span {
  width: 20%;
  display: inline-block;
  h4 {
    text-align: 'center';
  }
}
.row-span1 {
  width: 10%;
  display: inline-block;
}
.divPancl {
  margin-top: 12px;
  .ivu-collapse-content {
    background-color: #e7ecf7 !important;
  }
}
</style>
